import React, { useState, useRef, useEffect } from 'react';
import GetInTouchForm from '../../GetinTouchform/GetinTouch';
import colors from '../../ColorConfig/colorconfig';

const PortfolioBanner = () => {
  const [showGetInTouch, setShowGetInTouch] = useState(false);
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger animations when component mounts
    setIsVisible(true);
    
    // Cleanup function
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Function to show GetInTouch form
  const handleContactClick = (e) => {
    e.preventDefault();
    setShowGetInTouch(true);
    document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
  };

  // Function to close GetInTouch form
  const closeGetInTouch = () => {
    setShowGetInTouch(false);
    document.body.style.overflow = 'auto'; // Re-enable scrolling
  };

  // Dummy data
  const bannerData = {
    title: "Our Transformative Journeys: A Portfolio of Success",
    description: "Explore the impactful solutions we've delivered, showcasing our commitment to innovation, quality, and client satisfaction across diverse industries.",
    imageUrl: "https://i.pinimg.com/1200x/62/7a/d4/627ad40e9a051b681433320df6aa3533.jpg"
  };

  return (
    <section 
      ref={sectionRef} 
      className="portfolio-banner"
      style={{ backgroundColor: colors.bodyBlack }}
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Text Content */}
          <div className={`col-md-6 ${isVisible ? 'text-content-visible' : 'text-content-hidden'}`}>
            <h1 className="banner-title">
              {bannerData.title}
            </h1>
            <p className="banner-description">
              {bannerData.description}
            </p>
            <button
              onClick={handleContactClick}
              className="btn btn-primary banner-cta-btn"
            >
              Start Your Project
            </button>
          </div>

          {/* Image Content */}
          <div className={`col-md-6 ${isVisible ? 'image-content-visible' : 'image-content-hidden'}`}>
            <div className="image-container">
              <img 
                src={bannerData.imageUrl} 
                alt="Portfolio" 
                className="banner-image"
              />
            </div>
          </div>
        </div>
      </div>

      {showGetInTouch && (
                   <div className="modal-overlay" onClick={closeGetInTouch}>
                     <div className="modal-content-custom" onClick={(e) => e.stopPropagation()}>
                       <button className="close-button" onClick={closeGetInTouch}>
                         &times;
                       </button>
                       <GetInTouchForm isModal={true} />
                     </div>
                   </div>
                 )}

      <style jsx>{`
        .portfolio-banner {
          min-height: 100vh;
          display: flex;
          align-items: center;
          padding: 60px 0;
          position: relative;
          overflow: hidden;
        }
        
        .banner-title {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          color: ${colors.white};
          background: linear-gradient(
            90deg,
            ${colors.white},
            ${colors.primary},
            ${colors.white}
          );
          background-size: 200% auto;
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: textShine 8s ease-in-out infinite;
        }
        
        .banner-description {
          font-size: 1.2rem;
          margin-bottom: 2rem;
          color: ${colors.gray};
          opacity: 0;
          animation: fadeIn 1s ease forwards 0.5s;
        }
        
        .banner-cta-btn {
          background-color: ${colors.primary};
          border: none;
          color: ${colors.white};
          padding: 12px 30px;
          font-size: 1.1rem;
          font-weight: 600;
          border-radius: 50px;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
          opacity: 0;
          animation: fadeIn 1s ease forwards 0.8s;
        }
        
        .banner-cta-btn:hover {
          background-color: ${colors.primaryHover};
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        }
        
        .banner-cta-btn:active {
          transform: translateY(-1px);
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
        }
        
        .banner-cta-btn::after {
          content: "";
          display: inline-block;
          height: 100%;
          width: 100%;
          border-radius: 50px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          transition: all 0.4s;
          background-color: ${colors.primary};
        }
        
        .banner-cta-btn:hover::after {
          transform: scaleX(1.4) scaleY(1.6);
          opacity: 0;
        }
        
        .image-container {
          position: relative;
          padding: 20px;
        }
        
        .image-container::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 15px;
          // background: linear-gradient(45deg, ${colors.primaryTransparent}, transparent);
          z-index: 1;
        }
        
        .banner-image {
          width: 100%;
          height: auto;
          border-radius: 15px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
          animation: float 6s ease-in-out infinite;
          transform-origin: center center;
        }
        
        .text-content-hidden {
          opacity: 0;
          transform: translateX(-50px);
        }
        
        .text-content-visible {
          opacity: 1;
          transform: translateX(0);
          transition: all 1s ease;
        }
        
        .image-content-hidden {
          opacity: 0;
          transform: translateX(50px);
        }
        
        .image-content-visible {
          opacity: 1;
          transform: translateX(0);
          transition: all 1s ease 0.3s;
        }
        
      
        
        @keyframes float {
          0% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(1deg); }
          100% { transform: translateY(0px) rotate(0deg); }
        }
        
        @keyframes textShine {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes scaleIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        
        /* Responsive adjustments */
        @media (max-width: 768px) {
          .portfolio-banner {
            padding: 40px 0;
          }
          
          .banner-title {
            font-size: 2rem;
          }
          
          .banner-description {
            font-size: 1rem;
          }
          
          .row {
            flex-direction: column-reverse;
          }
          
          .col-md-6 {
            margin-bottom: 30px;
          }
        }
      `}</style>
    </section>
  );
};

export default PortfolioBanner;